'use strict';

var collection = require('../internals/collection');

var collectionWeak = require('../internals/collection-weak'); // `WeakSet` constructor
// https://tc39.github.io/ecma262/#sec-weakset-constructor


collection('WeakSet', function (get) {
  return function WeakSet() {
    return get(this, arguments.length ? arguments[0] : undefined);
  };
}, collectionWeak, false, true);